import Http from '@/services/Http';
import config from '@/config';

const path = '/organizations/user-requests';
const documentsPath = '/envelopes/user_request';
const storagePath = '/items/user_request';

const backupDocuments = new Http(documentsPath, config.api);
const backup = new Http(path, config.api);
const storageDocuments = new Http(storagePath, config.api);

backup.create = (data) => backup.post(data);

backup.list = (pathParams) =>
  backup.get('', '', pathParams === undefined ? '' : `?${pathParams}`);
backup.show = (uuid) => backup.get(uuid);
backup.listDocuments = (uuid) => backupDocuments.get(`${uuid}/documents/`);
backup.listItems = (uuid) => storageDocuments.get(`${uuid}/documents`);

backup.downloadDocument = (uuid, documentUuid) =>
  backupDocuments.get(`${uuid}/documents/${documentUuid}/download`, '', '', {
    responseType: 'json',
  });

backup.downloadStorageItem = (uuid, documentUuid) =>
  storageDocuments.get(`${uuid}/documents/${documentUuid}/download`, '', '', {
    responseType: 'json',
  });

export default backup;
